import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
// reactstrap components
import { Container } from 'reactstrap';

// core components
import AuthFooter from '../components/Footers/AuthFooter.js';

import Login from '../views/auth/Login';
import Signup from '../views/auth/Signup';
import ForgotPassword from '../views/auth/ForgotPassword';

const Auth = (props) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '85vh',
        }}
      >
        <Switch>
          {/* {getRoutes(routes)} */}
          <Route path="/auth/login" exact>
            <Login />
          </Route>
          <Route path="/auth/signup" exact>
            <Signup />
          </Route>
          <Route path="/auth/forgotPassword" exact>
            <ForgotPassword />
          </Route>

          <Redirect from="*" to="/admin/index" />
        </Switch>
      </div>

      <Container fluid style={{ bottom: 0, position: 'fixed', height: '15vh' }}>
        <AuthFooter />
      </Container>
    </>
  );
};

export default Auth;
